const downloadCard = {
	el: {
		btnDownloadCard: document.querySelector('.js-download-card')
	},

	fxGetCard (e) {
		const el = e.currentTarget,
			data = new FormData(),
			valToken = document.querySelector('input[name="__RequestVerificationToken"]')

		data.append('Name', el.dataset.name)
		data.append('NumberCard', el.dataset.numberCard)
		data.append('FiscalNumber', el.dataset.fiscalCard)

		if(valToken.value) {
			data.append('__RequestVerificationToken', valToken.value)
		}

		fetch(el.dataset.endpoint, {
			method: 'POST',
			body: data
		})
			.then(response => {
				const mediaFile = response.blob()
				return mediaFile
			})
			.then(mediaFile => {
				const url = URL.createObjectURL(mediaFile),
					link = document.createElement('a')
				
				link.href = url
				link.classList.add('d-none')
				link.download = el.dataset.cardDesignation
				link.click()
				URL.revokeObjectURL(url)
			})
			.catch(error => {
				console.log(error)
			})
	},

	events() {
		this.el.btnDownloadCard.addEventListener('click', e => {
			this.fxGetCard(e)
		})
	},

	init () {
		if(!this.el.btnDownloadCard) return
		this.events()
	}
}

downloadCard.init()